import { jsx as _jsx } from "react/jsx-runtime";
import { amendmentsTextsPath, getInvoicesApprovalMethodChangeBullet } from '~/business-logic/amendmentsLogic';
import { useLocaleKeys } from '~/i18n';
import { approvalMethodNoticePeriodModel, relationshipModel } from '~/models';
import AmendmentChangesInAgreementView from './AmendmentChangesInAgreementView';
import { SpecificTerm } from './CommonComponents';
const AgreementInvoicesApprovalMethod = (props)=>{
    const { relationship, testId } = props;
    const { t: amendmentsTexts } = useLocaleKeys(amendmentsTextsPath);
    const { t: viewTexts } = useLocaleKeys('pages.agreementMinisite.agreementView');
    const updated = relationshipModel.updatedInvoicesApprovalMethod(relationship);
    const actual = relationshipModel.actualInvoicesApprovalMethod(relationship);
    const isAutoApproval = approvalMethodNoticePeriodModel.isAutoApproval(actual);
    const changeBullet = updated ? getInvoicesApprovalMethodChangeBullet({
        originalApprovalMethod: relationship.invoicesApprovalMethod,
        newApprovalMethod: updated.value(),
        texts: amendmentsTexts
    }) : null;
    return isAutoApproval || updated ? /*#__PURE__*/ _jsx(SpecificTerm, {
        field: viewTexts.outOfScopeCharges(),
        value: approvalMethodNoticePeriodModel.invoicesDescription(actual),
        testId: testId + 'invoice-notice-period',
        changes: changeBullet && /*#__PURE__*/ _jsx(AmendmentChangesInAgreementView, {
            disableBorderRadius: true,
            items: [
                changeBullet
            ],
            autoApprovalDate: relationshipModel.updatedInvoicesApprovalMethodAutoApprovalDate(relationship),
            testId: testId + 'invoice-notice-changes'
        })
    }) : null;
};
export default AgreementInvoicesApprovalMethod;
